module.exports = __webpack_public_path__ + "img/Bulgaria.f08bb61f.gif";